/**
 * buildUserActions
 *
 * Converts a user's permission config and feature flags into an array of
 * action strings that HelpCenterModal uses to filter articles by
 * `requiredAction`.
 *
 * See: /ai/feature analysis/help center/permissions-help-center-alignment-guide.md
 */

const CONFIG_TO_ACTION = {
  isAdmin: 'ADMIN',
  isSelfService: 'SELF_SERVICE',
  isTrafficker: 'TRAFFICKER',
  isPartner: 'PARTNER',
  exportData: 'EXPORT_DATA',
  amplify: 'AMPLIFY',
  configurator: 'CONFIGURATOR',
  billing: 'BILLING',
  hasInsights: 'INSIGHTS',
  isProcessor: 'PROCESSOR',
  priceVisible: 'PRICE_VISIBLE',
  isPacing: 'PACING',
  isBeta: 'BETA',
};

export const buildUserActions = (userConfig, userFeatures, orgLevel) => {
  const actions = [];

  // Config-based actions
  if (userConfig) {
    Object.entries(CONFIG_TO_ACTION).forEach(([key, action]) => {
      if (userConfig[key]) {
        actions.push(action);
      }
    });
  }

  // Feature-based actions
  if (userFeatures) {
    Object.keys(userFeatures).forEach((feature) => {
      if (feature !== 'ENABLED') {
        actions.push(`FEATURE_${feature}`);
      }
    });
  }

  // Org-level actions (used by Tasks for PLATFORM-level gating)
  if (orgLevel) {
    actions.push(`LEVEL_${orgLevel}`);
  }

  return actions;
};
